<div class="right-side p-5">
  <h2>Proposal Dashboard</h2>
  <div class="section mt-2">
    <form [formGroup]="verifyProposalForm">
      <div class="row">
        <div class="mt-1">
          <!--SEARCH-->
          <div class="search">
            <div class="row">

              <div class="text-end">
                <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
              </div>


              <div class="col-lg-7 col-sm-12">
                <div class="search-container">
                  <mat-form-field class="search-input w-75" appearance="outline">
                    <mat-label>Search</mat-label>
                    <input matInput formControlName="search" />
                  </mat-form-field>
                  <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(verifyProposalForm.get('search')?.value ?? '')" id="btnSearch">
                    <i class="bi bi-search fs-4"></i>
                  </button>
                  <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                    <i class="bi bi-arrow-clockwise fs-4"></i>
                  </button>
                </div>
                <div *ngIf="verifyProposalForm.get('search')?.invalid && (verifyProposalForm.get('search')?.touched || verifyProposalForm.get('search')?.dirty)">
                  <small *ngIf="verifyProposalForm.get('search')?.errors?.['pattern']" class="text-danger">
                    Invalid search term.
                  </small>
                </div>

              </div>             
            </div>
          </div>         
          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="dateOfSubmission" matSortDirection="desc" matSortDisableClear>
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
              </ng-container>
              <ng-container matColumnDef="proposalId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal Id</th>
                <td mat-cell *matCellDef="let el"> {{el.proposalId}} </td>
              </ng-container>           

              <ng-container matColumnDef="createdProposalId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal Id</th>
                <td mat-cell *matCellDef="let el">
                  <a *ngIf="el.status === 'Approved'" class="text-primary no-underline" (click)="action(el.proposalUserId,'view')" style="cursor: pointer;">{{ el.createdProposalId }}</a>
                  <a *ngIf="el.status === 'Rejected'" class="text-primary no-underline" (click)="action(el.proposalUserId,'view')" style="cursor: pointer;">{{ el.createdProposalId }}</a>
                  <a *ngIf="el.status === 'Verification Pending'" class="text-primary no-underline" (click)="action(el.proposalUserId,'update')" style="cursor: pointer;">{{ el.createdProposalId }}</a>
                  <a *ngIf="el.status === 'Rejected for Query'" class="text-primary no-underline" (click)="action(el.proposalUserId,'update')" style="cursor: pointer;">{{ el.createdProposalId }}</a>
                </td>
              </ng-container>

              <ng-container matColumnDef="shortNameOfOrganisation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>IA Short Name</th>
                <td mat-cell *matCellDef="let el"> {{el.shortNameOfOrganisation}} </td>
              </ng-container>
              <ng-container matColumnDef="dateOfSubmission">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Submission Date</th>
                <td mat-cell *matCellDef="let el"> {{el.dateOfSubmission}} </td>
              </ng-container>
              <ng-container matColumnDef="interventionName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention</th>
                <td mat-cell *matCellDef="let el"> {{el.interventionName}} </td>
              </ng-container>
              <ng-container matColumnDef="componentName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Component</th>
                <td mat-cell *matCellDef="let el"> {{el.componentName}} </td>
              </ng-container>
              <!--added by rp-->
              <ng-container matColumnDef="targetMSME">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Target MSME</th>
                <td mat-cell *matCellDef="let el"> {{el.targetMSME}} </td>
              </ng-container>
              <ng-container matColumnDef="approvedTargetMSME">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Approved Target MSME</th>
                <td mat-cell *matCellDef="let el"> {{el.approvedTargetMSME}} </td>
              </ng-container>
              <ng-container matColumnDef="balanceTargetMSME">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Balance Target MSME</th>
                <td mat-cell *matCellDef="let el"> {{el.balanceTargetMSME}} </td>
              </ng-container>
              <ng-container matColumnDef="fromDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>From Date</th>
                <td mat-cell *matCellDef="let el"> {{el.fromDate}} </td>
              </ng-container>
              <ng-container matColumnDef="toDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>To Date</th>
                <td mat-cell *matCellDef="let el"> {{el.toDate}} </td>
              </ng-container>
              <!--rp ends-->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let el">
                  {{ el.status }}<br />
                  <button *ngIf="el.status === 'Approved'" class="btn btn-success btn-sm" (click)="action(el.proposalUserId,'view')"><i class="bi bi-eye"></i> View</button>
                  <button *ngIf="el.status === 'Rejected'" class="btn btn-danger btn-sm" (click)="action(el.proposalUserId,'view')"><i class="bi bi-eye"></i> View</button>
                  <button *ngIf="el.status === 'Verification Pending'" class="btn btn-info btn-sm" (click)="action(el.proposalUserId,'update')"><i class="bi bi-check-circle"></i> Verify</button>
                  <button *ngIf="el.status === 'Rejected for Query'" class="btn btn-warning btn-sm" (click)="action(el.proposalUserId,'update')"><i class="bi bi-eye"></i> View</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="statusDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Date</th>
                <td mat-cell *matCellDef="let el"> {{el.statusDate}} </td>
              </ng-container>
              <ng-container matColumnDef="remarks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Remarks</th>
                <td mat-cell *matCellDef="let el"> {{el.remarks}} </td>
              </ng-container>
              <ng-container matColumnDef="iaid">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Other Details</th>
                <td mat-cell *matCellDef="let el">
                  <button class="btn btn-primary btn-sm" (click)="showOtherDetail(el.iaid)"><i class="bi bi-eye-fill"></i> Show</button>
                </td>
              </ng-container>
              <!--added by rp-->
              <ng-container matColumnDef="WorkOrderExtension">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Work Order Management
                </th>
                <td mat-cell *matCellDef="let el" class="text-center">

                  <!-- chnage given by harshal on 23-04-2026
                  <button mat-stroked-button
                          color="primary"
                          (click)="onViewWorkOrderExtension(woePopup, el.proposalUserId, el.proposalId)"
                          [disabled]="!isRenewEnabled(el.toDate)"
                          matTooltip="Renew Work Order Extension"
                          class="mt-1">
                    <i class="bi bi-arrow-repeat" style="font-size: 1rem;"></i>
                    <span>Renew</span>
                  </button> -->

                  
<button mat-stroked-button
        color="primary"
        (click)="onViewWorkOrderExtension(woePopup, el.proposalUserId, el.proposalId)"
[disabled]="!(isExpired(el.toDate) && el.balance !== 0)"
        matTooltip="Renew Work Order Extension"
        class="mt-1">

  <i class="bi bi-arrow-repeat" style="font-size: 1rem;"></i>
  <span>Renew</span>

</button>


                 
                  <button mat-flat-button
                          color="accent"
                          (click)="onViewHistory(woePopup, el.proposalUserId)"
                          matTooltip="View Work Order Extension History"
                          class="btn-sm mt-1">
                    <i class="bi bi-card-text" style="font-size: 1rem;"></i>
                    <span>View</span>
                  </button>
                </td>
              </ng-container>            
              <ng-container matColumnDef="Download">
                <th mat-header-cell *matHeaderCellDef>Work Order Download</th>
                <td mat-cell *matCellDef="let el">
                  <a class="text-decoration-none btn btn-warning btn-sm mt-1" *ngIf="el.documentPath"
                     (click)="onDownload(el.documentPath, el.documentName); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
                    <i class="bi bi-download"></i> Download
                  </a>
                  <button class="btn btn-primary btn-sm mt-1" (click)="openFilePreviewDialog(el.documentPath, el.documentName)" *ngIf="el.documentPath"><i class="bi bi-eye"></i> View File</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Proposal">
                <th mat-header-cell *matHeaderCellDef>Proposal Download</th>
                <td mat-cell *matCellDef="let el">
                  <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="el.uploadProposalPath"
                     (click)="onDownload(el.uploadProposalPath, el.uploadProposalDocument); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
                    <i class="bi bi-download"></i> Download
                  </a>
                  <button class="btn btn-primary btn-sm mt-1" (click)="openFilePreviewDialog(el.uploadProposalPath, el.uploadProposalDocument)" *ngIf="el.uploadProposalPath"><i class="bi bi-eye"></i> View File</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              Row shown when there is no matching data.
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
              </tr>
            </table>
          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>
        </div>
      </div>
    </form>
    <!--added by rp-->
    <form [formGroup]="workOrderExtForm">
      <div class="row">
        <ng-template #woePopup class="dialog-container" fxLayout="column" fxFill let-data>
          <h1 mat-dialog-title>
            {{ data.mode === 'Renew' ? 'Work Order Management Section' : 'Work Order Extension History' }}

            <button mat-icon-button mat-dialog-close aria-label="Close" (click)="onClosePopup()" class="btn-cross" title="close">
              <i class="bi bi-x-lg"></i>
            </button>
          </h1>
          <div mat-dialog-content>
            <div class="row mb-1">
              <div class="col-md-12">

                <div class="form-section p-3 border rounded mb-4" *ngIf="data.mode === 'Renew'">
                  <h5 class="mb-3 text-primary">Work Order Extension Details</h5>

                  <div class="row mb-1">
                    <div class="col-md-12">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Intervention Name</mat-label>
                        <input matInput type="text" formControlName="interventionName" placeholder="Enter intervention name">
                      </mat-form-field>
                    </div>
                    <div class="col-md-12">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Interest Name</mat-label>
                        <input matInput type="text" formControlName="interestName" placeholder="Enter interest name">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row mb-1">
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Proposal Id</mat-label>
                        <input matInput type="text" formControlName="createdProposalId" placeholder="Enter proposal id">
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>IA Short Name</mat-label>
                        <input matInput type="text" formControlName="shortNameOfOrganisation" placeholder="Enter short name of organisation">
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Balance Target MSME</mat-label>
                        <input matInput type="text" formControlName="balanceTargetMSME" placeholder="Enter Balance MSME">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row mb-1">
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>From Date</mat-label>
                        <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                        <mat-datepicker #fromPicker (closed)="onDateChange()"></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>To Date</mat-label>
                        <input matInput [matDatepicker]="toPicker" formControlName="toDate"
                               [min]="workOrderExtForm.get('fromDate')?.value" readonly>
                        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                        <mat-datepicker #toPicker (closed)="onDateChange()"></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="col-md-4">
                      <mat-form-field appearance="outline" class="w-100 mb-2">
                        <mat-label>Upload File (Only PDF file)</mat-label>
                        <input matInput formControlName="fileUpload" [value]="fileName || ''" readonly>
                        <button mat-icon-button matSuffix (click)="fileInput.click()" type="button">
                          <i class="bi bi-upload"></i>
                        </button>
                      </mat-form-field>
                      <input type="file" hidden #fileInput (change)="onUploadProposalFileChange($event)" accept=".pdf,.docx,.jpg,.jpeg,.png">
                    </div>
                  </div>

                  <div class="row mb-3 align-items-center">
                    <div class="col">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Remark</mat-label>
                        <textarea matInput rows="2" formControlName="remark"></textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <button class="btn btn-success me-2" (click)="submitWOE()" [disabled]="workOrderExtForm.get('balanceTargetMSME')?.value <= 0" type="submit">
                        Submit
                      </button>
                      <button class="btn btn-secondary" (click)="resetWOE()" type="button">
                        Reset
                      </button>
                    </div>
                  </div>

                </div>
                <hr *ngIf="data.mode === 'Renew'">

                <div class="table-section p-3 border rounded">
                  <h5 class="mb-3 text-primary">Work Order Extension History</h5>

                  <div class="table-responsive m-4">
                    <table mat-table [dataSource]="dataSourceWorkOrderExtension" matSort
                           class="table table-striped table-bordered table-hover"
                           matSortActive="FromDate" matSortDirection="asc" matSortDisableClear>

                      <ng-container matColumnDef="Sr.No">
                        <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                        <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                      </ng-container>
                      <ng-container matColumnDef="workOrderExtenstionId">
                        <th mat-header-cell *matHeaderCellDef>WorkOrder Extenstion Id</th>
                        <td mat-cell *matCellDef="let el"> {{el.workOrderExtenstionId}} </td>
                      </ng-container>
                      <ng-container matColumnDef="fromDate">
                        <th mat-header-cell *matHeaderCellDef>From Date</th>
                        <td mat-cell *matCellDef="let el"> {{el.fromDate}} </td>
                      </ng-container>
                      <ng-container matColumnDef="toDate">
                        <th mat-header-cell *matHeaderCellDef>To Date</th>
                        <td mat-cell *matCellDef="let el"> {{el.toDate}} </td>
                      </ng-container>
                      <ng-container matColumnDef="remark">
                        <th mat-header-cell *matHeaderCellDef>Remark</th>
                        <td mat-cell *matCellDef="let el"> {{el.remark}} </td>
                      </ng-container>
                      <ng-container matColumnDef="workorder">
                        <th mat-header-cell *matHeaderCellDef>Work Order Download</th>
                        <td mat-cell *matCellDef="let el">
                          <a class="btn btn-warning btn-sm text-decoration-none"
                             *ngIf="el.workOrderExtensionPath"
                             (click)="onDownload(el.workOrderExtensionPath, el.workOrderExtension); $event.preventDefault()">
                            <i class="bi bi-download"></i> Download
                          </a>
                          <button class="btn btn-primary btn-sm mt-1"
                                  (click)="openFilePreviewDialog(el.workOrderExtensionPath, el.workOrderExtension)"
                                  *ngIf="el.workOrderCertificatePath">
                            <i class="bi bi-eye"></i> View File
                          </button>

                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedWorkOrderExtensionColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedWorkOrderExtensionColumns;"></tr>

                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6">No data matching the filter</td>
                      </tr>
                    </table>
                  </div>

                  <mat-paginator #paginator class="demo-paginator"
                                 (page)="onPageWOEChange($event)"
                                 [length]="woeLength"
                                 [pageSize]="woePageSize"
                                 [showFirstLastButtons]="woeShowFirstLastButtons"
                                 [pageSizeOptions]="woePageSizeOptions"
                                 [hidePageSize]="woeHidePageSize"
                                 [pageIndex]="woePageIndex"
                                 aria-label="Select page">
                  </mat-paginator>

                </div>
              </div>
            </div>
          </div>

          <div mat-dialog-actions class="action-buttons">
            <button mat-button mat-dialog-close (click)="onClosePopup()">Close</button>
          </div>
        </ng-template>
      </div>
    </form>   
    <!--rp ends-->
  </div>
</div>
